import { useState } from 'react';
import { Check, X } from 'lucide-react';
import { Button } from './ui/button';

interface DraftEditorProps {
  subject: string;
  body: string;
  busy: boolean;
  onSave: (body: string, subject: string) => void;
  onCancel: () => void;
}
const unsafeSubject = ['\r', '\n', '\u0000'];
function hasUnsafeCharacter(subject: string) {
  return unsafeSubject.some(character => subject.includes(character));
}
function subjectProblem(subject: string) {
  if (!subject.trim() || subject.length > 200) return 'Use 1-200 characters.';
  if (hasUnsafeCharacter(subject)) return 'Line breaks are not allowed.';
  return '';
}

export function DraftEditor({ subject, body, busy, onSave, onCancel }: DraftEditorProps) {
  const [value, setValue] = useState(body);
  const [title, setTitle] = useState(subject);
  const problem = subjectProblem(title);
  const savable = !busy && Boolean(value.trim()) && !problem;
  return <div className="editor">
    <label htmlFor="email-subject">Subject</label>
    <p className="muted text-sm">Keep every invoice number in the subject so the customer can match the reminder.</p>
    <input
      id="email-subject"
      value={title}
      onChange={event => setTitle(event.target.value)}
      disabled={busy}
      maxLength={200}
      aria-invalid={Boolean(problem)}
    />
    {problem && <p className="muted text-sm" role="alert">{problem}</p>}
    <label htmlFor="email-body">Email body</label>
    <p className="muted text-sm">You can adjust the wording. Amounts, dates, invoice details, and the signature stay tied to the ledger.</p>
    <textarea
      id="email-body"
      value={value}
      onChange={event => setValue(event.target.value)}
      disabled={busy}
      autoFocus
      spellCheck
      rows={18}
    />
    <div className="editor-actions">
      <Button variant="outline" onClick={onCancel} disabled={busy}><X aria-hidden />Cancel</Button>
      <Button onClick={() => onSave(value, title)} disabled={!savable}><Check aria-hidden />Save changes</Button>
    </div>
  </div>;
}
